(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  if (!customElements.get('expandable-text')) {
    customElements.define('expandable-text', class ExpandableText extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('.expandable-text__content');
        this.toggle = this.querySelector('.expandable-text__toggle');
        this.expanded = false;
        this.collapsedHeight = 0;
        this.fullHeight = 0;
      }

      connectedCallback() {
        this.setAttribute('aria-expanded', 'false');
        this.measureHeights();
        this.checkTruncation();

        if (this.toggle) {
          this.toggle.addEventListener('click', this.handleToggle.bind(this));
        }

        this.resizeObserver = new ResizeObserver(() => {
          // Skip resize handling while collapse animation is in progress
          // (measureHeights temporarily sets maxHeight='none' which cancels the transition)
          if (!this.expanded && !this.hasAttribute('data-collapsing')) {
            this.measureHeights();
            this.checkTruncation();
          }
        });
        this.resizeObserver.observe(this.content);
      }

      disconnectedCallback() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }

      measureHeights() {
        if (!this.content) return;

        // Measure collapsed height (with line clamp)
        this.collapsedHeight = this.content.clientHeight;

        // Measure full height (without line clamp)
        const originalDisplay = this.content.style.display;
        const originalLineClamp = this.content.style.webkitLineClamp;
        const originalOverflow = this.content.style.overflow;
        const originalMaxHeight = this.content.style.maxHeight;

        this.content.style.display = 'block';
        this.content.style.webkitLineClamp = 'unset';
        this.content.style.overflow = 'visible';
        this.content.style.maxHeight = 'none';

        this.fullHeight = this.content.scrollHeight;

        this.content.style.display = originalDisplay;
        this.content.style.webkitLineClamp = originalLineClamp;
        this.content.style.overflow = originalOverflow;
        this.content.style.maxHeight = originalMaxHeight;
      }

      checkTruncation() {
        if (!this.content) return;

        const isTruncated = this.fullHeight > this.collapsedHeight + 2;

        if (isTruncated) {
          this.setAttribute('data-truncated', '');
          if (this.toggle) {
            this.toggle.classList.remove('hidden');
          }
        } else {
          this.removeAttribute('data-truncated');
          if (this.toggle) {
            this.toggle.classList.add('hidden');
          }
        }
      }

      handleToggle() {
        this.expanded = !this.expanded;

        if (this.expanded) {
          // Expanding: set aria-expanded first so line-clamp is removed
          this.setAttribute('aria-expanded', 'true');
          if (this.toggle) {
            this.toggle.setAttribute('aria-expanded', 'true');
          }

          // Animate max-height from collapsed to full
          this.content.style.maxHeight = this.collapsedHeight + 'px';
          // Force reflow
          this.content.offsetHeight;
          this.content.style.maxHeight = this.fullHeight + 'px';

          // After animation, remove max-height constraint
          setTimeout(() => {
            this.content.style.maxHeight = '';
          }, 400);
        } else {
          // Collapsing: add collapsing state so gradient starts fading in immediately
          this.setAttribute('data-collapsing', '');

          // Get current height for animation start
          const currentHeight = this.content.scrollHeight;

          // Use Web Animations API for reliable height animation
          // (CSS transitions can be cancelled by other CSS property changes)
          const animation = this.content.animate([
            { maxHeight: currentHeight + 'px' },
            { maxHeight: this.collapsedHeight + 'px' }
          ], {
            duration: 400,
            easing: 'ease-in-out',
            fill: 'forwards'
          });

          animation.onfinish = () => {
            // Clean up animation and apply final state
            animation.cancel();
            this.removeAttribute('data-collapsing');
            this.setAttribute('aria-expanded', 'false');
            this.content.style.maxHeight = '';
            if (this.toggle) {
              this.toggle.setAttribute('aria-expanded', 'false');
            }
          };
        }

        this.dispatchEvent(new CustomEvent('expandable-text:toggle', {
          bubbles: true,
          detail: { expanded: this.expanded }
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class AppBlockInPrice extends HTMLElement {
    connectedCallback() {
      const target = document.getElementById(this.dataset.target);
      if (target) target.appendChild(this);
    }
  }
  customElements.define('app-block-in-price', AppBlockInPrice);

  } catch(e) { console.error(e); }
})();
})();
